import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLanguage } from "../contexts/LanguageContext";
import { T } from "../i18n/strings";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const { lang } = useLanguage();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => { if (user) nav("/admin", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="login-page">
      <div className="pw-eyebrow">{T.labels.editorial[lang]}</div>
      <h1 className="font-serif-display text-4xl font-bold text-[#081422] mt-2 mb-6">{T.labels.login[lang]}</h1>
      <form onSubmit={submit} className="pw-window-frame p-8 space-y-5">
        <div>
          <label className="pw-eyebrow block mb-2">{T.labels.email[lang]}</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="pw-input" data-testid="login-email" />
        </div>
        <div>
          <label className="pw-eyebrow block mb-2">{T.labels.password[lang]}</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="pw-input" data-testid="login-password" />
        </div>
        {error && <div className="text-[#8B0000] font-mono-meta text-xs uppercase tracking-widest" data-testid="login-error">{error}</div>}
        <button type="submit" disabled={loading} className="pw-btn w-full justify-center" data-testid="login-submit">
          {loading ? "..." : T.labels.login[lang]}
        </button>
      </form>
    </div>
  );
}
